module.exports = __webpack_public_path__ + "static/media/safari.a81ac119.png";